module.exports = __webpack_public_path__ + "img/setting-line.01c0f1d8.svg";